import { useEffect } from "react";
export default function Impressum() {
    useEffect(() => {
        document.title = "Impressum – Tuscher Helmut Betonrohrfallen";
    }, []);
    return (
        <div className="max-w-3xl mx-auto px-4 py-12 text-sm leading-relaxed">
            <h1 className="text-2xl font-semibold mb-6">Impressum</h1>

            <p className="mb-4">
                Angaben gemäß § 5 TMG
            </p>

            <p className="mb-4">
                <strong>Helmut Tuscher</strong><br />
                Betonrohrfallen<br />
                Hofmark 50<br />
                93326 Abensberg<br />
                Deutschland
            </p>

            <p className="mb-4">
                <strong>Kontakt</strong><br />
                Telefon: +49 163 4194552<br />
                E-Mail: info@tuscherhelmut-betonrohrfallen.de
            </p>

            <p className="mb-4">
                <strong>Umsatzsteuer</strong><br />
                Umsatzsteuer-Identifikationsnummer gemäß §27 a Umsatzsteuergesetz:<br />
                <em>entfällt gemäß §19 UStG (Kleinunternehmerregelung)</em>
            </p>

            <p className="mb-4">
                <strong>Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</strong><br />
                Helmut Tuscher<br />
                Adresse wie oben
            </p>

            <p className="text-slate-500 text-xs mt-8">
                Quelle: Eigene Angaben
            </p>
        </div>
    );
}
